import { Flower2, Heart, Crown, Gem, Sparkles } from "lucide-react";

export const GIFT_ICON = {
  rose: Flower2,
  heart: Heart,
  crown: Crown,
  diamond: Gem,
  superfan: Sparkles,
};

export const dollars = (cents) => `${(cents || 0) < 0 ? "−" : ""}$${(Math.abs(cents || 0) / 100).toFixed(2)}`;
